import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useGlobalContext } from '../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

const EmailLanguageSelector = ({ 
  displayFlag = true, 
  onLanguageChange = () => {} 
}) => {
  const { t } = useTranslation();
  const { 
    languages: globalLanguages, 
    currentLanguage: globalCurrentLanguage,
    defaultLanguage: globalDefaultLanguage
  } = useGlobalContext();

  const containerRef = useRef(null);
  const isFirstRender = useRef(true);
  
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return globalCurrentLanguage || 
           globalLanguages.find(lang => lang.code === globalDefaultLanguage) || 
           globalLanguages[0];
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (globalCurrentLanguage && globalCurrentLanguage.code !== selectedLanguage?.code) {
      setSelectedLanguage(globalCurrentLanguage);
    }
  }, [globalCurrentLanguage]);

  useEffect(() => {
    if (!isFirstRender.current && onLanguageChange && selectedLanguage) {
      onLanguageChange(selectedLanguage);
    }
    isFirstRender.current = false;
  }, [selectedLanguage, onLanguageChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && dropdownOpen) {
        setDropdownOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [dropdownOpen]);

  if (!globalLanguages || globalLanguages.length < 1) return null;

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  const handleLanguageSelect = (lang, e) => {
    e.preventDefault();
    setSelectedLanguage(lang);
    setDropdownOpen(false);
  };

  return (
    <div className="langueMail ng-scope" ref={containerRef}>
      <ul className="nav navbar-nav">
        <li className={`dropdown ${dropdownOpen ? 'open' : ''}`}>
          <button
            id="language-menu-button"
            className="dropdown-toggle link-dropdown"
            aria-haspopup="true"
            aria-expanded={dropdownOpen ? "true" : "false"}
            onClick={toggleDropdown}
            style={{ cursor: 'pointer', background: 'none', border: 'none', width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            aria-labelledby="langue_du_mail"
          >
            <span id="langue_du_mail" className="medium-label ng-scope">
              {t("Langue du mail")}
            </span>
            
            <span className="dropdown-selected-item" style={{marginTop:3}}>
              <span id="cardLanguageText" className="medium-label ng-binding">
                {selectedLanguage?.name}
              </span>
              {displayFlag && (
                <img
                  id="cardLanguageImg"
                  src={`assets/images/flags/${selectedLanguage?.code}.png`}
                  className="img-thumbnail icon-small"
                  style={{marginBottom:5}}
                  alt={`Drapeau ${selectedLanguage?.name}`}
                />
              )}
            </span>
          </button>
          
          {dropdownOpen && (
            <ul 
              className="dropdown-menu" 
              role="listbox"
              aria-labelledby="language-menu-button"
            >
              {globalLanguages.map(lang => (
                <li 
                  key={lang.code} 
                  className="ng-scope"
                  role="option"
                  aria-selected={selectedLanguage?.code === lang.code}
                >
                  <button
                    className="dropdown-item"
                    onClick={(e) => handleLanguageSelect(lang, e)}
                    style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', padding: '3px' }}
                  >
                    <span className="capitalize ng-binding">
                      {lang.name}
                    </span>
                    {displayFlag && (
                      <img
                        src={`assets/images/flags/${lang.code}.png`}
                        className="img-thumbnail icon-small"
                        style={{marginLeft: 8,marginBottom:7}}
                        alt=""
                      />
                    )}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </li>
      </ul>
    </div>
  );
};

EmailLanguageSelector.propTypes = {
  displayFlag: PropTypes.bool,
  onLanguageChange: PropTypes.func
};

export default EmailLanguageSelector;